import React from 'react';
import HdSetupGuideLink from '../../../../docs/components/setup-guide-link/HdSetupGuideLink';
import { SetupGuideLinkRequiredParams } from '../../../../docs/utils/setupGuideLinkHandler';

export function getSnowflakeValidationErrorMessage() {
  const snowflakeHostUrlSetupGuide: SetupGuideLinkRequiredParams = {
    setupGuideLink: '/destinations/data-warehouses/snowflake/#obtain-your-snowflake-account-url',
    section: 'destination-settings',
    label: 'account-url-field-help-text'
  };

  return (
    <span>
      Invalid Connection URL. {` `}
      <HdSetupGuideLink
        {...snowflakeHostUrlSetupGuide}
        size='sm'
        icon='right'
        dataId='snowflake-account-url'
      >
        Need Help?
      </HdSetupGuideLink>
    </span>
  );
}
